import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import { requestGetSaleorderProducts, requestSaleorderItemDelete, requestGetProducts, requestUpdateSaleorder } from "../../Redux/actions";
import { bindActionCreators } from "redux";
import { de, el } from "date-fns/locale";
import { set } from "date-fns";

function ProductSaleOrder(props) {
  const [products, setProducts] = useState(null);
  const [productsAll, setProductsAll] = useState([]);
  const [filterItem, setFilterItem] = useState([]);
  const [id, setid] = useState(0);
  const [user, setuser] = useState(null);
  const [showTable, setShowTable] = useState(true);
  const [deleted, setDeleted] = useState(false);
  const [updated, setUpdated] = useState(false);

  useEffect(() => {    
    if (props.saleorderId) {
      setid(props.saleorderId);
      let data1 = JSON.parse(localStorage.getItem("user"));
      setuser(data1);
      console.log(props.saleorderId);
      props.requestGetSaleorderProducts({
        data: {
          param1: localStorage.getItem("companyToken"),
          param2: props.saleorderId.toString(),
          token: data1.data.userToken
        },
      });
    }
  }, [props.saleorderId]);

  useEffect(() => {
    let jobsData = props.data.getSOProductsData;
    console.log(jobsData);
    if (jobsData !== undefined) {
      if (jobsData.data) {
        setProducts(jobsData.data.data);
        // const jsonString = `[{"id":13688,"productId":"000008","description":"Pickle","product_price":40.0000,"sale_price":40.0000,"membership_price":0.0000,"vip_price":0.0000,"barcode":null},{"id":13687,"productId":"000007","description":"Chunda","product_price":45.0000,"sale_price":45.0000,"membership_price":0.0000,"vip_price":0.0000,"barcode":null},{"id":13686,"productId":"000006","description":"Moramba","product_price":45.0000,"sale_price":45.0000,"membership_price":0.0000,"vip_price":0.0000,"barcode":null},{"id":13685,"productId":"000005","description":"Thecha","product_price":40.0000,"sale_price":40.0000,"membership_price":0.0000,"vip_price":0.0000,"barcode":null},{"id":13684,"productId":"000004","description":"Chapati","product_price":10.0000,"sale_price":10.0000,"membership_price":0.0000,"vip_price":0.0000,"barcode":null},{"id":13683,"productId":"000003","description":"Rice","product_price":20.0000,"sale_price":20.0000,"membership_price":0.0000,"vip_price":0.0000,"barcode":null},{"id":13682,"productId":"000002","description":"Ragi","product_price":25.0000,"sale_price":25.0000,"membership_price":0.0000,"vip_price":0.0000,"barcode":null},{"id":13681,"productId":"000001","description":"Jowar","product_price":25.0000,"sale_price":25.0000,"membership_price":0.0000,"vip_price":0.0000,"barcode":null}]`;

        let products = [];
        try {
          // if (products == []) {
          products = JSON.parse(localStorage.getItem("products"));
          setProductsAll(products);
          // }
        } catch (error) {
          console.error("Failed to parse JSON:", error);
        }
      }
    }
  }, [props.data.getSOProductsData]);

  const handleSearchChange = (value) => {
    setShowTable(true);
    const filtered = productsAll.filter(item =>
      item.description.toLowerCase().includes(value)
    );
    setFilterItem(filtered);
    if (filtered.length > 0) {
      ItemDiv(filtered);
    }
  }

  function ItemDiv({ filterItem }) {
    if (!Array.isArray(filterItem) || filterItem.length === 0) {
      return <div className="card">No products found.</div>;
    }
    return (
      <div className="card">
        <table className="table table-striped">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th hidden></th>
              <th scope="col">Product Name</th>
              <th scope="col">Price</th>
            </tr>
          </thead>
          <tbody>
            {filterItem.map((item, index) => (
              <tr key={index} onClick={() => handleAddToCart(item)} style={{ cursor: "pointer" }}>
                <th scope="row">{index + 1}</th>
                <td hidden>{item.token}</td>
                <td>{item.description || "—"}</td>
                <td>{item.sale_price ?? "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  const handleAddToCart = (arr) => {
    console.log(arr);
    const index = products.findIndex(item => item.id === arr.id);

    if (index !== -1) {
      // Item exists — increase qty
      const updatedCart = [...products];
      updatedCart[index].qty += 1;
      // return updatedCart;
    } else {
      // Item doesn't exist — add new with qty:       
      const newItem = [
        {
          id: 0,
          productId: arr.token.toString(),
          description: arr.description,
          price: arr.sale_price,
          qty: 1,
          amount: arr.sale_price
        }];
      // const updatedProducts = [...products, ...newItem]; // ← Now it's flat
      setProducts(prev => [...prev, ...newItem]);
      // console.log(updatedProducts);
    }
    setShowTable(false);
    filterItem = [];
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setShowTable(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);
  // useEffect(() => {
  //   console.log(props.data.getProductsData);
  //   if (productsAll === undefined) {
  //   let jobsData = props.data.getProductsData;
  //   console.log("prodcuts", jobsData.data);
  //   if (jobsData !== undefined) {
  //     if (jobsData.data) {
  //       setProductsAll(jobsData.data.data);
  //     }
  //   }
  // }
  // }, [props.data.getProductsData])
  function deletedata(id) {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setDeleted(true);
        props.requestSaleorderItemDelete({
          data: {
            userToken: user.data.userToken,
            cart_Id: id.toString()
          },
        });
      }
    })
  }

  //delete
  useEffect(() => {
    let deleteSOItemData = props.data.deleteSOItemData;
    if (deleteSOItemData !== undefined && deleted) {
      if (deleteSOItemData?.data?.status == 1) {
        Swal.fire({
          title: 'Good job!',
          text: 'Cart Item deleted successfully..',
          icon: 'success'
        });
        if (!products) {
          return;
        }
        else {
          const deletedId = parseInt(deleteSOItemData?.data?.data, 10);
          let item = products.find(item => item.id === deletedId);
          if (item) {
            setProducts(prevItems => prevItems.filter(item => item.id !== deletedId));
          }
          // props.data.deleteCartItemData = undefined;
        }
      }
      else{
        Swal.fire({
          title: 'Error!',
          text: deleteSOItemData?.data?.message,
          icon: 'error'
        });
      }
      setDeleted(false);
    }
  }, [props.data.deleteSOItemData]);

  useEffect(() => {
    console.log("Products updated:", products);
  }, [products]);

  const handleQuantityChange = (id, delta) => {
    console.log(id);
    setProducts(prevItems =>
      prevItems.map(item =>
        item.id === id
          ? { ...item, qty: Math.max(0, item.qty + delta), amount: item.price * (item.qty + delta) }
          : item
      )
    );
  };

  const handleInputChange = (id, value) => {
    const numericValue = parseInt(value, 10);
    setProducts(prevItems =>
      prevItems.map(item =>
        item.id === id
          ? { ...item, qty: isNaN(numericValue) ? 0 : numericValue, amount: item.price * numericValue }
          : item
      )
    );
  };

  function UpdateCartProducts() {
    if (products === null || products.length === 0) {
      Swal.fire({
        title: 'No products in cart',
        text: 'Please add products to the cart before updating.',
        icon: 'warning',
        confirmButtonText: 'OK'
      });
      return;
    }
    else if (user === null) {
      Swal.fire({
        title: 'User not found',
        text: 'Please log in to update the cart.',
        icon: 'warning',
        confirmButtonText: 'OK'
      });
      return;
    }
    else {
      setUpdated(true);
      console.log(products);
      props.requestUpdateSaleorder({
        data: {
          userToken: user.data.userToken,
          compToken: localStorage.getItem("companyToken"),
          token: props.saleorderId.toString(),
          items: products
        },
      });
    }
  }

  useEffect(() => {
    let updateCartData = props.data.updateSaleOrderData;
    if (updateCartData !== undefined && updated) {
      if (updateCartData?.data?.status === 1) {
        Swal.fire({
          title: 'Good job!',
          text: 'Cart updated successfully.',
          icon: 'success'
        });
        setUpdated(false);
        props.data.updateSaleOrderData = undefined;
        props.onClose();
      } else {
        Swal.fire({
          title: 'Error',
          text: updateCartData?.data?.message || 'Failed to update cart.',
          icon: 'error'
        });
      }
    }
  }, [props.data.updateSaleOrderData]);

  return (
    products === null ? <div>Loading...</div> :
      <div className="contact-view">
        <div className="row" style={{ position: "relative" }}>
          {/* <div className="col-md-6"><h6>Cart product of </h6> <h4>{props.cname}</h4></div> */}
          <div className="col-md-6">
            <div className="row">
              <div style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                zIndex: 10000,
                background: "white" // optional, but useful if you want to visually separate
              }}>
                <input type="text" placeholder="search..." className="form-field" onChange={e => handleSearchChange(e.target.value)}></input>
                {showTable && <ItemDiv filterItem={filterItem} handleAddToCart={handleAddToCart} />}
              </div>
            </div>
          </div>
        </div>
        <table key={products.length} className="table table-striped" style={{ marginTop: '25px' }}>
          <thead>
            <tr>
              <th scope="col">#</th>
              <th hidden></th>
              <th scope="col">Product Name</th>
              <th scope="col">Price</th>
              <th scope="col">Quantity</th>
              <th scope="col">Total Price</th>
            </tr>
          </thead>
          <tbody>
            {products.map((item, index) => (
              <tr key={index}>
                <th scope="row">{index + 1}</th>
                <td hidden>{item.productId}</td>
                <td>{item.description}</td>
                <td>{item.price}</td>
                <td><button onClick={() => handleQuantityChange(item.id, -1)} class="badge badge-opacity-warning" style={{ border: "0px", background: "#00ff00", marginLeft: "5px", }}><i class="fa fa-minus"></i></button>
                  <input type="number" value={item.qty} onChange={e => handleInputChange(item.id, e.target.value)}></input> <button onClick={() => handleQuantityChange(item.id, 1)} class="badge badge-opacity-warning" style={{ border: "0px", background: "#00ff00", marginLeft: "5px", }}><i class="fa fa-plus"></i></button></td>
                <td>{item.amount}</td>
                <td><button class="badge badge-opacity-danger" style={{ border: "0px", background: "#fea8a9", marginLeft: "5px", }}
                  onClick={() => { deletedata(item.id); }}><i class="fa fa-trash"></i></button></td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="row">
          <div className="col-md-12">
            <button className="btn btn-primary" onClick={() => { UpdateCartProducts() }}>Update Products</button>
          </div>
        </div>
      </div>
  )
}

const mapStateToProps = (state) => {
  return { data: state.data };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ requestGetSaleorderProducts, requestSaleorderItemDelete, requestGetProducts, requestUpdateSaleorder }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProductSaleOrder);